// Provinces that stopped falling back on 1 Nov 2026. Offsets are minutes east of UTC.
// After each zone's transition, the legal offset is the old daylight offset all year.
// Browsers that still have the old IANA data report standard time in winter; the
// delta puts our labels back on the booked wall-clock time.

const PERMANENT = {
  "America/Vancouver": { permanent: -420, transitionMs: Date.UTC(2026, 10, 1, 9, 0, 0) },
  "Canada/Pacific": { permanent: -420, transitionMs: Date.UTC(2026, 10, 1, 9, 0, 0) },
  "America/Winnipeg": { permanent: -300, transitionMs: Date.UTC(2026, 10, 1, 7, 0, 0) },
  "Canada/Central": { permanent: -300, transitionMs: Date.UTC(2026, 10, 1, 7, 0, 0) },
  "America/Rainy_River": { permanent: -300, transitionMs: Date.UTC(2026, 10, 1, 7, 0, 0) },
  "America/Edmonton": { permanent: -360, transitionMs: Date.UTC(2026, 10, 1, 8, 0, 0) },
  "Canada/Mountain": { permanent: -360, transitionMs: Date.UTC(2026, 10, 1, 8, 0, 0) },
  "America/Yellowknife": { permanent: -360, transitionMs: Date.UTC(2026, 10, 1, 8, 0, 0) },
  "America/Inuvik": { permanent: -360, transitionMs: Date.UTC(2026, 10, 1, 8, 0, 0) }
}

export function canada2026LegalOffsetMinutes(iana, instant) {
  const zone = PERMANENT[iana]
  if (!zone || !instant) return null
  const ms = instant instanceof Date ? instant.getTime() : new Date(instant).getTime()
  if (Number.isNaN(ms) || ms < zone.transitionMs) return null
  return zone.permanent
}

// Minutes to add to a browser-zoned display. 0 when the browser already matches the law.
export function canada2026DisplayDeltaMinutes(iana, instant, actualOffsetMinutes) {
  const legal = canada2026LegalOffsetMinutes(iana, instant)
  if (legal == null || actualOffsetMinutes == null || Number.isNaN(actualOffsetMinutes)) return 0
  return legal - actualOffsetMinutes
}
